import React, { useState, useEffect } from "react";
import { LoginScreen } from "./components/LoginScreen";
import { Challenge } from "./components/Challenge";
import { sha256 } from "js-sha256";
import { getLevel } from "./helpers/utilFunctions";

function App() {
  const [level, setLevel] = useState<number>(0);

  useEffect(() => {
    const storedLevel = localStorage.getItem("level");

    if (storedLevel) {
      let recoveredLevel: number = getLevel(storedLevel);
      setLevel(recoveredLevel as number);
    }
  }, []);

  const updateLevel = (newLevel: number) => {
    setLevel(newLevel);
    // want to get the hash of a string always
    let hashToken: string = process.env.REACT_APP_SECRET_HASH_TOKEN as string;
    localStorage.setItem("level", sha256(hashToken + newLevel.toString()));
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen bg-black font-roboto text-hackerGreen">
      <div className="absolute hidden lg:block top-10 right-10">
        <span className="text-sm text-white">
          Want to protect your systems? Check out{" "}
          <a href="https://aeglos.ai" className="text-hackerGreen">
            aeglos.ai
          </a>
        </span>
      </div>
      <div className="absolute top-8 left-8">
        <a href="https://aeglos.ai" className="text-hackerGreen">
          <img src="/logo.png" alt="description" className="w-16" />
        </a>
      </div>

      {level === 0 ? (
        <LoginScreen updateLevel={updateLevel} />
      ) : (
        <Challenge level={level} updateLevel={updateLevel} />
      )}
    </div>
  );
}

export default App;
